import IdentificationTagList from './components/identificationTagList/IdentificationTagList';
import IdentificationTagDetails from './components/identificationTagDetails/IdentificationTagDetails';
import { useParams } from 'react-router-dom';
import styles from './IdentificationTagTab.module.scss';

const IdentificationTagTab = () => {
    const { type } = useParams<{ type: string, itemId: string }>();

    return <div className={styles.container}>
    {
        (type === 'list' ? <IdentificationTagList /> : <IdentificationTagDetails />)                
    }
    </div>;
}

export default IdentificationTagTab;